<template>
  <!-- 患者検索 -->
  <div id="AppPatientManagementSleepResult">
    <!-- 検索結果 -->
    <div class="columns">
      <div class="column is-full">
        <b-field
          horizontal
          label="患者検索結果"
          style="float: right; white-space: nowrap"
        >
          <b-select position="is-right" v-model="perPage">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div>
      <b-table
        :data="searchResult"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :pagination-size="paginationSize"
        :backend-sorting="true"
        @sort="sortPressed"
        v-on:page-change="sortPressed"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
      >
        <template slot-scope="props">
          <b-table-column
            field="patientCode"
            label="患者コード"
            sortable
            centered
          >
            {{ props.row.patientCode }}
          </b-table-column>

          <b-table-column field="caution" centered>
            <div v-if="props.row.caution">
              <b-icon icon="account-alert"> </b-icon>
            </div>
            <div v-if="props.row.followUpCall">
              <b-icon icon="volume-high" type="is-info"> </b-icon>
            </div>
          </b-table-column>

          <b-table-column
            field="patientName"
            label="患者名"
            sortable
            centered
          >
            {{ props.row.patientName }}
          </b-table-column>

          <b-table-column
            field="patientNameKana"
            label="患者名（カナ）"
            sortable
            centered
          >
            {{ props.row.patientNameKana }}
          </b-table-column>

          <b-table-column field="branchCodes" label="支店" sortable centered>
            {{ getBranchNames(props.row) }}
          </b-table-column>

          <b-table-column
            field="patientPhone"
            label="電話番号"
            sortable
            centered
          >
            {{ props.row.patientPhone }}
          </b-table-column>

          <b-table-column
            label="営業担当者"
            sortable
            centered
          >
            {{ props.row.staffName }}
          </b-table-column>

          <b-table-column field="isDeleted" label="状態" sortable centered>
            {{ props.row.isDeleted | deletedFilter }}
          </b-table-column>

          <b-table-column label="編集" centered>
            <b-button
              class="button is-primary has-text-centered"
              icon-left="mdi mdi-cog"
              native-type="button"
              @click="gotoEdit(props.row)"
            ></b-button>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import orderBy from "lodash/orderBy";
export default {
  components: {},

  props: ["value", "searchConditions"],

  name: "AppPatientManagementSleepResult",

  methods: {
    sortPressed: function (field, order) {
      this.searchResult = orderBy(this.searchResult, field, order);
    },

    gotoEdit: function (row) {
      this.$router.push({
        name: "AppPatientManagementEditPatientSleep",
        params: {
          code: row.patientCode,
          searchConditions: this.searchConditions,
        },
      });
      return;
    },

    getBranchNames: function (patient) {
      // 重複除外
      const codes = [];
      for (const productDetail of patient.productDetails) {
        const code = productDetail.branchCode;
        const exists = codes.includes(code);
        if (!exists) {
          codes.push(code);
        }
      }

      // 名称取得
      const names = [];
      for (const code of codes) {
        const refBranch = this.branchMaster.find(
          (elem) => elem.branchCode == code
        );
        if (refBranch) {
          names.push(refBranch.branchName);
        } else {
          names.push("");
        }
      }

      // 名称結合
      const res = names.join("\n");

      return res;
    },

    formatStaffNames: function (patient) {
      // 重複除外
      const codes = [];
      const names = [];
      for (const productDetail of patient.productDetails) {
        const code = productDetail.staffCode;
        const exists = codes.includes(code);
        if (!exists) {
          codes.push(code);
          names.push(productDetail.staffName);
        }
      }

      return names;
    },
  },
  data() {
    const branchMaster = JSON.parse(sessionStorage.getItem("branchMaster"));
    const officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    return {
      branchMaster,
      officeMaster,
      searchResult: [],
      isShowGoogleMap: false,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 10,
    };
  },
  filters: {},
  computed: {},
  watch: {
    value: function () {
      this.searchResult = JSON.parse(JSON.stringify(this.value));
      return;
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppPatientManagementSleepResult.vue